import { BedrockMessages } from '../interfaces/bedrock-chat.interface';

export type InputType = 'text' | 'image' | 'voice_to_text' | 'voice_to_voice';

export function generateBedrockMessage(
  role: 'user' | 'agent',
  sessionId: string,
  content: { message: string; type: InputType },
  enableMessageId?: boolean,
  explicitMessageId?: string
): BedrockMessages {
  const { message, type } = content;
  const messageId = explicitMessageId ?? (enableMessageId ? crypto.randomUUID() : undefined);
  return {
    role: role,
    sessionId: sessionId,
    messageId: messageId,
    content: {
      message: message,
      type: type,
      timestamp: new Date().toISOString(),
    },
  };
}

export function mergeConsecutiveBy<T>(items: T[], keyFn: (item: T) => unknown, mergeFn: (a: T, b: T) => T): T[] {
  const merged: T[] = [];
  for (const item of items) {
    const last = merged[merged.length - 1];
    if (last && keyFn(last) === keyFn(item)) {
      merged[merged.length - 1] = mergeFn(last, item);
    } else {
      merged.push(item);
    }
  }
  return merged;
}

export function normaliseBrandName(brand: string | undefined | null): string {
  if (!brand) return '';
  return brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase();
}

export const capitaliseSentenceStarts = (text: string) =>
  text.replace(/(^|[.!?]\s+)([a-z])/g, (match) => match.toUpperCase());
